import { render, staticRenderFns } from "./worker.vue?vue&type=template&id=7965b579&scoped=true"
import script from "./worker.vue?vue&type=script&lang=js"
export * from "./worker.vue?vue&type=script&lang=js"
import style0 from "./worker.vue?vue&type=style&index=0&id=7965b579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965b579",
  null
  
)

export default component.exports